/**
 * Calendar Legend Component
 *
 * Displays color legend for event types.
 */

import { CALENDAR_LEGEND_ITEMS } from '../utils';

export function CalendarLegend() {
  return (
    <div className="flex flex-wrap gap-3">
      {CALENDAR_LEGEND_ITEMS.map((item) => (
        <div key={item.key} className="flex items-center gap-1.5">
          <div
            className="w-3 h-3 rounded-sm"
            style={{
              backgroundColor: item.color,
              border: `1px solid ${item.borderColor}`,
            }}
          />
          <span className="text-xs text-muted-foreground">{item.label}</span>
        </div>
      ))}
    </div>
  );
}
